"use client"

import { useAppSelector } from "@/lib/redux/hooks";

export const useAirlines = () => useAppSelector(state => state.flight.airlineData)